import { render, staticRenderFns } from "./RankCard.vue?vue&type=template&id=b471efde&scoped=true"
import script from "./RankCard.vue?vue&type=script&lang=js"
export * from "./RankCard.vue?vue&type=script&lang=js"
import style0 from "./RankCard.vue?vue&type=style&index=0&id=b471efde&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b471efde",
  null
  
)

export default component.exports